export default "__VITE_ASSET__Dj6PuqWZ__"